import React, { useContext } from 'react';
import ConfigContext from '../../contexts/ConfigContext';
import { Helmet } from 'react-helmet-async';

const cacheBust = process.env.REACT_APP_BUILD_TIME
  ? `?v=${encodeURIComponent(process.env.REACT_APP_BUILD_TIME)}`
  : "";
const v = (path: string) => `${path}${cacheBust}`;

// Unified branding: browser tab title and SEO title are always "The Back Room"
// regardless of which tenant tab is active.
const BRAND_TITLE = 'The Back Room™';

type Props = {
}

const Style = ({  }: Props) => {
  const {config} = useContext(ConfigContext);

  const getBrandStyle = (path: string) => {
    return v(`/css/${config?.general?.style}/${path}`);
  }

  const style = config?.general?.style

  if (!style) {
    return (<Helmet>
      <meta charSet="utf-8" />
      <title>{BRAND_TITLE}</title>
      <meta name="description" content={config?.general?.description}/>
    </Helmet>)
  }

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{BRAND_TITLE}</title>
      <meta name="description" content={config?.general?.description}/>

      {/* Legacy CSS */}
      <link rel="stylesheet" href={v("/css/fonts.css")}/>
      <link rel="stylesheet" href={v("/css/index.css")}/>
      <link rel="stylesheet" href={v("/css/departments.css")}/>
      <link rel="stylesheet" href={v("/css/store.css")}/>
      <link rel="stylesheet" href={v("/css/card.css")}/>
      <link rel="stylesheet" href={v("/css/categories.css")}/>
      <link rel="stylesheet" href={v("/css/quickbar.css")}/>
      <link rel="stylesheet" href={v("/css/menubar.css")}/>
      <link rel="stylesheet" href={v("/css/footer.css")}/>
      <link rel="stylesheet" href={v("/css/itemdetails.css")}/>
      <link rel="stylesheet" href={v("/css/cartdrawer.css")}/>
      <link rel="stylesheet" href={v("/css/checkout.css")}/>

      {/* Default CSS */}
      <link rel="stylesheet" href={getBrandStyle("default/header.css")} />
      <link rel="stylesheet" href={getBrandStyle("default/menu.css")} />
      <link rel="stylesheet" href={getBrandStyle("default/categories.css")} />
      <link rel="stylesheet" href={getBrandStyle("default/itemdetails.css")} />
      <link rel="stylesheet" href={getBrandStyle("default/cart.css")} />
      <link rel="stylesheet" href={getBrandStyle("default/ageGate.css")} />
      <link rel="stylesheet" href={getBrandStyle("default/store.css")} />
      <link rel="stylesheet" href={getBrandStyle("default/footer.css")} />

      {/* Tablet CSS */}
      <link rel="stylesheet" href={getBrandStyle("tablet/header-1024.css")} />
      <link rel="stylesheet" href={getBrandStyle("tablet/menu-1024.css")} />
      <link rel="stylesheet" href={getBrandStyle("tablet/menu-800.css")} />
      <link rel="stylesheet" href={getBrandStyle("tablet/categories-800.css")} />
      <link rel="stylesheet" href={getBrandStyle("tablet/itemdetails-1024.css")} />

      {/* Mobile CSS */}
      <link rel="stylesheet" href={getBrandStyle("mobile/header-640.css")} />
      <link rel="stylesheet" href={getBrandStyle("mobile/header-480.css")} />
      <link rel="stylesheet" href={getBrandStyle("mobile/menu-640.css")} />
      <link rel="stylesheet" href={getBrandStyle("mobile/categories-640.css")} />
      <link rel="stylesheet" href={getBrandStyle("mobile/categories-480.css")} />
      <link rel="stylesheet" href={getBrandStyle("mobile/cart-640.css")} />
      <link rel="stylesheet" href={getBrandStyle("mobile/cart-480.css")} />
      <link rel="stylesheet" href={getBrandStyle("mobile/store-480.css")} />
      <link rel="stylesheet" href={getBrandStyle("mobile/store-640.css")} />
    </Helmet>
  )
}

export default Style;